module.exports = __webpack_public_path__ + "img/exam2.ac60f3e7.png";